import axios from 'axios';

import HttpError from './HttpError';
import NetworkError from './NetworkError';

function parseAxiosError(axiosError: unknown): HttpError | NetworkError {
  // NOTE(Ryan): Still puzzling about how to best adapt DefaultAPIErrorHandler here.
  //             For now I'm just setting up a framework for getting the error typed
  //             based on https://fettblog.eu/typescript-typing-catch-clauses/
  //             and the axios docs https://axios-http.com/docs/handling_errors

  if (axios.isAxiosError(axiosError)) {
    let error: HttpError | NetworkError;
    if (axiosError.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      error = new HttpError(axiosError.response);
    } else if (axiosError.request) {
      // The request was made but no response was received. Probably a timeout, possibly other network issues
      // `e.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
      error = new NetworkError(`Failed Request to '${axiosError.config?.url}'`);
    } else {
      // Something happened in setting up the request that triggered an Error
      // NOTE(Ryan) we probably want to re-throw in this case?
      throw new Error(axiosError.message);
    }

    // log the parsed error (except during unit tests), its stack seems to be slightly better than the raw error
    if (!process.env.JEST_WORKER_ID) {
      console.error(error); // eslint-disable-line no-console
    }
    return error;
  }

  // NOTE(Ryan) This happens in rare cases, best to log the error and rethrow so the issue is found
  console.error(axiosError); // eslint-disable-line no-console
  throw new Error('parseAxiosError called with a non-axios error.');
}

export default parseAxiosError;
